import {Component} from 'preact';
import ProgressMeter from '../../common/ProgressMeter';
import RatingStars from '../../common/RatingStars';
import pluralize from 'pluralize';
import equals from 'ramda/src/equals';
import pick from 'ramda/src/pick';

const lblNoReviews = upi.i18n.getTextFromKey( 'lbl-noReviews' );
const lblFilterByStarCount = upi.i18n.getTextFromKey( 'lbl-filterByStarCount', 'Filter by %COUNT% star ratings' );
const wrdStar = upi.i18n.getTextFromKey( 'wrd-Star', 'Star' );

class ReviewSummary extends Component {

    shouldComponentUpdate( nextProps, nextState ) {
        const propList = ['ratingValues', 'totalPublishedReviews'];

        return !equals(
            pick( propList, nextProps.reviewSummary ),
            pick( propList, this.props.reviewSummary )
        );
    }

    render( props, state, context ) {

        const {brandId, reviewSummary, onRatingFilterChange} = props;
        let {ratingValues, totalPublishedReviews} = reviewSummary;

        if ( !ratingValues ) {
            ratingValues = RATINGS_EMPTY;
        }

        const ratingDisplay = Number( reviewSummary.ratingAverage ).toFixed( 1 );

        return (
            <div className="mb-4 flex-1 max-w-sm md:mr-12">
                {totalPublishedReviews > 0
                    ?
                    <div data-testid="rating-stars-summary" className="bg-grey-darkest text-white p-4">
                        <div className="flex items-center justify-center">
                            <span className="text-4xl font-bold">{ratingDisplay}</span>
                            <div className="ml-2">
                                <RatingStars
                                    className="text-lg"
                                    color="white"
                                    rating={ratingDisplay}
                                    showDataAsLabel={true}
                                />
                                <span className="text-lg">
                                    {`${totalPublishedReviews} ${pluralize( 'Review', totalPublishedReviews )}`}
                                </span>
                            </div>
                        </div>

                    </div>
                    :
                    <div className="bg-grey-darkest text-white p-4">
                        <div className="flex items-center justify-center">
                            <h1 data-testid="no-reviews">{lblNoReviews}</h1>
                        </div>
                    </div>
                }

                <div className="progress-meter-wrapper mt-4">
                    {ratingValues.map( ( rating, i ) => {
                        const count = i + 1;
                        const lblFilterBy = lblFilterByStarCount.replace( '%COUNT%', count );
                        // only enable filter action and tooltips if there is content to filter
                        const filterActionProps = (totalPublishedReviews > 0)
                            ? {
                                'onClick': () => onRatingFilterChange( {rating: count.toString()} ),
                                'data-tooltip': lblFilterBy
                            }
                            : {};

                        return (
                            <ProgressMeter
                                key={`star-meter-${count}`}
                                focusable={rating.percent > 0}
                                height="4"
                                className="mt-1"
                                animated
                                {...filterActionProps}
                                title={lblFilterBy}
                                value={rating.percent / 100}
                                labelLeft={`${count} ${pluralize( wrdStar, count )}`}
                                labelRight={`${parseInt( rating.percent )}%`}
                            />
                        );
                    } ).reverse()}
                </div>
            </div>
        );
    }
}

const RATING_VALUE = {count: 0, percent: 0};
const RATINGS_EMPTY = [RATING_VALUE, RATING_VALUE, RATING_VALUE, RATING_VALUE, RATING_VALUE];

ReviewSummary.defaultProps = {
    reviewSummary: {
        totalPublishedReviews: 0,
        ratingValues: RATINGS_EMPTY
    }
};

export default ReviewSummary;